<div class="component-container">
  <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <div class="margin-header-align section-heading text-uppercase">
      <div>{{ 'regep.bank-account-details.title' | translate }}</div>
      <div class="section-buttons" *ngIf="sectionButtonsVisible() | async">
        <lock-unlock-buttons
          [showLockButton]="isDetailsView"
          [showUnlockButton]="isDetailsView"
          [isLocked]="getSectionLocked()"
          [areButtonsDisabled]="!(isModeratorRole() && editabilityBasedOnProcessStatus.internalRoles)"
          (lockButtonClickedEvent)="lockSection()"
          (unLockButtonClickedEvent)="unlockSection()"></lock-unlock-buttons>
        <i
          *ngIf="isDetailsView"
          class="pi pi-comment"
          [ngClass]="isCommentVisible || getSectionComment() ? 'lock-icon-style' : 'unlock-icon-style'"
          [pTooltip]="showCommentTooltip() ? ('comment-section.comment-tooltip' | translate) : null"
          [tooltipPosition]="showCommentTooltip() ? 'bottom' : null"
          (click)="showComment()"></i>
      </div>
    </div>
  </div>
  <section-comment
    [isCommentTextInputVisible]="isModeratorRole() && (isCommentVisible || getSectionComment())"
    [isCommentTextVisible]="!isModeratorRole()"
    [isCommentSaveVisible]="!getSectionComment()"
    [isCommentDeleteButtonDisabled]="!editabilityBasedOnProcessStatus.internalRoles"
    [comment]="getSectionComment()"
    (saveCommentEvent)="updateComment($event)"
    (deleteCommentEvent)="deleteComment()"
    (changeTextEvent)="changeCommentText.emit($event)"></section-comment>
  <div class="form-background margin-align" [ngClass]="{ 'disable-section': getSectionLocked() && applicationId }">
    <div class="top-bottom-margin">
      <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 form-rows">
        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 bottom-padding">
            <label class="ui-g-5 field-label text-right-align required" for="bank_account_holder">
              {{ 'regep.bank-account-details.account-holder' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="regulatoryData.bank_account_holder"
              name="bank_account_holder"
              #bank_account_holder="ngModel"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 bottom-padding">
            <label class="ui-g-5 field-label text-right-align required" for="bank_name">
              {{ 'regep.bank-account-details.bank' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="regulatoryData.bank_name"
              name="bank_name"
              #bank_name="ngModel"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 bottom-padding">
            <label class="ui-g-5 field-label text-right-align required" for="bank_iban">
              {{ 'regep.bank-account-details.iban' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="regulatoryData.bank_iban"
              name="bank_iban"
              #bank_iban="ngModel"
              appIbanValid
              [onlyDE]="true"
              required
              [disabled]="isSectionDisabled" />
          </div>

          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12">
            <label class="ui-g-5 field-label text-right-align required" for="bank_bic">
              {{ 'regep.bank-account-details.bic' | translate }}
            </label>
            <input
              class="ui-input pInputText"
              pInputText
              [(ngModel)]="regulatoryData.bank_bic"
              name="bank_bic"
              #bank_bic="ngModel"
              required
              [disabled]="isSectionDisabled" />
          </div>
        </div>

        <div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12 invoice-details">
          {{ 'regep.bank-account-details.authorize-details-1' | translate }}
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 vertical-padding">
            <p-checkbox
              appEnterClick
              [label]="'regep.bank-account-details.invoice-process-due' | translate"
              [binary]="true"
              #due_invoice="ngModel"
              name="due_invoice"
              [(ngModel)]="regulatoryData.due_invoice"
              [disabled]="isSectionDisabled"></p-checkbox>
          </div>
          <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xsƒ-12 bottom-padding">
            <p-checkbox
              appEnterClick
              [label]="'regep.bank-account-details.invoice-process-credit' | translate"
              [binary]="true"
              name="credit_invoice"
              #credit_invoice="ngModel"
              [(ngModel)]="regulatoryData.credit_invoice"
              [disabled]="isSectionDisabled"></p-checkbox>
          </div>
          {{ 'regep.bank-account-details.authorize-details-2' | translate }}
        </div>
      </div>
    </div>
  </div>
</div>
